import { ref } from 'vue';

const getEmployers = () => {
    const employers_error = ref(null);
    const employers = ref(null);

    const loadEmployers = async () => {
      try {
        let data = await fetch("/api/employers");

        if (!data.ok) {
          throw Error("Can't load data");
        }

        employers.value = await data.json();

         //console.log('employers api', employers.value);
      } catch (err) {
        employers_error.value = err.message;
      }
    };

    return { employers, employers_error, loadEmployers};
}

export default getEmployers;